import React, { useEffect } from "react";
import { withRouter } from "react-router";
import { get, post } from "../../../api/axios";
import { Row, Col, Button, Container } from "react-bootstrap";
import { ValidatorForm } from "react-material-ui-form-validator";
import { FormControlLabel, Checkbox, Typography } from "@material-ui/core";

const NegocioCadetesDisponibles = props => {
    const [cadetes, setCadetes] = React.useState([]);

    useEffect(() => {
        get("/admin-negocios/cadetes").then(response => {
            setCadetes(response.data);
        });
    }, []);

    const disponible = (value, index) => {
        let cadetesTemp = cadetes.slice();
        cadetesTemp[index].disponible = value === 1 ? 1 : 0;
        setCadetes(cadetesTemp);
    };

    const handleSubmit = () => {
        let body = {
            cadetes: cadetes
        };
        post("/admin-negocios/cadetes/disponibles", body);
    };
    const renderCadetes = () => {
        let index = -1;
        return cadetes.map((cadete, key) => {
            let ind = ++index;
            return (
                <Row xs={{ span: 12, offset: 2 }} key={key}>
                    <Col xs className="checkbox checkboxCadete">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={cadetes[ind].disponible === 1}
                                    onChange={e =>
                                        disponible(cadetes[ind].disponible === 1 ? 0 : 1, ind)
                                    }
                                    value="Disponible"
                                />
                            }
                            label={`Esta disponible ${cadete.nombre} ${cadete.apellido}?`}
                        />
                    </Col>
                </Row>
            );
        });
    };
    return (
        <Container className="container-tournament-form">
            <ValidatorForm onSubmit={handleSubmit}>
                <Row>
                    {renderCadetes()}
                    <Col xs={{ span: 8, offset: 1 }}>
                        <div className="form-card-header">
                            <div className="buttons-header">
                                <Button
                                    size="large"
                                    variant="contained"
                                    className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-sizeLarge"
                                    onClick={() => props.history.goBack()}
                                >
                                    Volver
                                </Button>
                                <Button
                                    size="large"
                                    variant="contained"
                                    type="submit"
                                    className="ml-2 MuiButtonBase-root MuiButton-root ml-2 MuiButton-contained MuiButton-containedPrimary MuiButton-sizeLarge"
                                >
                                    Guardar
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </ValidatorForm>
        </Container>
    );
};

export default withRouter(NegocioCadetesDisponibles);
